export default __webpack_public_path__ + "static/media/logo_converted.a397f1dc.png";